import { useFeature } from 'common/hooks/useFeature';
import FEATURES from "src/core/constants/features";

export const useIsWireTransferForInvoicesFeatureEnabled = (): boolean =>
  useFeature(FEATURES.WIRE_TRANSFER_FOR_INVOICES);
